/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';


const Track = styled.div`
  display: flex;
  gap: 4px;
`;


const Pill = styled.div`
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: ${props => getBackground(props)};
`;


const getBackground = (props) =>
{
  const percentage = getProgressPercentage(props);

  return `linear-gradient(to right, var(--${props.color}-11) ${percentage}%, var(--${props.color}-5) ${percentage}%)`;
};


const getProgressPercentage = ({ index, progress }) =>
{
  const fraction = Math.min(Math.max(progress - index, 0), 1);

  return Math.round(fraction * 100);
};


export default ({ segments, progress, color = 'accent' }) =>
(
  <Track>
    {Array.from({ length: segments }, (_, index) => <Pill key = {index} index = {index} progress = {progress} color = {color} />)}
  </Track>
);
